// src/components/common/Spinner.jsx
import React from "react";
export default function Spinner({ size = "md", center = false }) {
  const s = { sm: "h-4 w-4", md: "h-8 w-8", lg: "h-12 w-12" }[size];
  return (
    <div className={center ? "flex justify-center items-center py-12" : ""}>
      <div className={`${s} animate-spin rounded-full border-2 border-primary-200 border-t-primary-600`} />
    </div>
  );
}
